<div *ngIf="(manageSelf && passwordExpirySettings.passwordExpiry && userLogged) || !manageSelf" style="background-color: white; border-radius: 6px; padding: 10px;">
  <div class="row">
    <div class="container-fluid">
      <div class="login-header text-center">
        <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
        <h3>Reset password</h3>
      </div>
    </div>
  </div>

  <ng-container *ngIf="userLogged!=undefined">
    <div class="row padding-bottom-base" *ngIf="!passwordExpirySettings.hasExpired">
      <div class="container-fluid text-center">
        <h4>Hi, {{this.userLogged.firstName}} {{this.userLogged.surname}}</h4>
        <p>
          Your password will expire in <strong>{{passwordExpirySettings?.passwordDaysExpire}}</strong> days!
        </p>
        <p class="padding-top-base padding-bottom-base">
          Please reset your password or skip this step.
        </p>
      </div>
    </div>

    <div class="row padding-bottom-base" *ngIf="passwordExpirySettings.hasExpired">
      <div class="container-fluid text-center">
        <h4>Hi, {{user.userName}}</h4>
        <p *ngIf="!passwordExpirySettings.checkFirstLogin">Your password has expired.</p>
        <p *ngIf="passwordExpirySettings.checkFirstLogin">Your organisation requires you to change your password on first login.</p>
        <p class="padding-top-base padding-bottom-base">Please reset your password.</p>
      </div>
    </div>
  </ng-container>

  <div class="row margin-top-base">
    <div class="container-fluid text-center">
      <button type="button" *ngIf="!passwordExpirySettings.hasExpired && !passwordExpirySettings.checkFirstLogin" class="btn btn-primary margin-right-base" (click)="onSkip()" [ngStyle]="{'background-color': this.sharedService?.ButtonColor?.value, 'color':  this.sharedService?.TextButtonColor?.value}">Skip</button>

      <button type="button" class="btn btn-primary" (click)="onReset()" [ngStyle]="{'background-color': this.sharedService.ButtonColor.value, 'color':  this.sharedService?.TextButtonColor?.value}">Reset password</button>
    </div>
  </div>

</div>

<ng-container *ngIf="manageSelf && (triggerObs$ | async)"></ng-container>
